import { Component } from '@angular/core';
@Component({
  selector: 'app-icons-demo-page',
  templateUrl: './icons-demo-page.component.html',
})
export class IconsDemoPageComponent {}
